import Vue from "vue";
import axios from "axios";
import { vuexOidcCreateStoreModule } from "vuex-oidc";
import { oidcSettings } from "../config/oidc";
import pyChar from "js-pinyin";
import store from "..";
import qs from "qs";
import gql from "graphql-tag";
import queryStr from "@/graphql/appCenter";
import manageGuide from "./manageGuide";
import appProjects from "./appProjects";

import { Message } from "element-ui";

const state = {
  loadingDataStart: false,
  hotsLoading: false,
  shortcutVisible: false,
  targetMessage: "",
  isCanFresh: true,
  isShow: false,
  apiMap: {
    todo: {
      url: "me/tasks/todo",
      query: "",
    },
    manage: {
      url: "me/processes/guest",
      query: {
        draft: false,
        limit: 10,
        start: 0,
        keyword: "",
        timestamps: "",
        statuses: "doing",
        locale: "zh",
      },
    },
    weituo: {
      url: "me/tasks/todo?entrust=true",
      query: "",
    },
    doing: {
      url: "me/processes/doing",
      query: {
        limit: 10,
        start: 0,
        keyword: "",
        sep: true,
      },
    },
    meApply: {
      url: "me/processes/doing",
      query: {
        limit: 10,
        start: 0,
        keyword: "",
        sep: false,
      },
    },
    done: {
      url: "me/processes/done",
      query: {
        limit: 10,
        start: 0,
        keyword: "",
      },
    },
    flow_cc: {
      url: "me/processes/cc",
      query: {
        limit: 10,
        start: 0,
        unread: false,
        keyword: "",
      },
    },
    appall: {
      url: "me/apps",
      query: "",
    },
  },
  dataSource: {
    todo: [],
    weituo: [],
    manage: [],
    doing: [],
    meApply: [],
    done: [],
    flow_cc: [],
  },
  dataLength: {
    todo: 0,
    weituo: 0,
    manage: 0,
    done: 0,
    doing: 0,
    meApply: 0,
    flow_cc: 0,
    //未读的抄送数量
    cc: 0,
    //进行中属于自己那方的数量
    medoing: 0,
  },
  appList: [],
  appLength: [0, 0],
  statsRes: [],
  otherAppList: {},
  userRecentApps: [],
  userHotApps: [],
  smartRecommendApps: [],
  recommends: [],
  userId: "",
  tags: [],
  otherTags: [],
  department: [],
  tagApps: [],
  wtThings: {
    entrustees: [],
    entrusters: [],
    total: 0,
  },
  process_pass: [],
  favorites: [],
  favoriteApps: [],
  tagsSort: {
    COMMON: {},
    DEPARTMENT: {},
  },
  zm: [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ],
  //由tagApps拿到的字母
  zimu: [],
  highlights: [],
  todoWeiTuo: [],
  appQuery: {
    seq: "",
    tag: "",
    department: "",
    other: "",
    zimu: "",
    blfs: "",
  },
  positionsMes: [],
  userInfos: {},
  appIdIcons: {},
  appVisits: {},
  isIdentity: "工号",
  totalTip: "",
  todayVisit: 1,
  totalVisit: 1,
  nowVisit: 1,
  recent: JSON.parse(localStorage.getItem("recent")) || [],
  //数字对应拼音:0-9
  numPychar: ["L", "Y", "E", "S", "S", "W", "L", "Q", "B", "J"],

  // 扩展字段
  BLFS: [],

  appVaryOnly: window.commonApi.varyTarget,
};

Vue.filter("noNum", function(sortTag) {
  // msg 为固定的参数 即是你需要过滤的数据
  let tags = sortTag ? sortTag.split("-") : [""];
  if (parseInt(tags[0]) >= 0) {
    return sortTag.replace(tags[0] + "-", "");
  } else {
    return sortTag;
  }
});

Vue.filter("noNum2", function(sortTag) {
  // msg 为固定的参数 即是你需要过滤的数据
  let tags = sortTag.split("-");
  let res = "";
  if (parseInt(tags[0]) >= 0) {
    res = sortTag.replace(tags[0] + "-", "");
  } else {
    res = sortTag;
  }
  return res.slice(0, 2);
});

const getters = {
  getAuth: () => store.state.oidcStore,
  getEmail: () => store.state.oidcStore.user.email,
  getUserInfo: () => store.state.userInfos,
  getId: () => store.state.userInfos.id,
  getAppList: (state) => state.appList,
  getRecommends: (state) => state.recommends,
  getRecents: (state) => state.userRecentApps,
  getHots: (state) => state.userHotApps,
  getTags: (state) => state.tags,
  getZimu: (state) => state.zimu,
  getAllZimu: (state) => state.zm,
  getOtherTags: (state) => state.otherTags,
  getBLFSTags: (state) => state.BLFS,
  getDep: (state) => state.department,
  getTagApps: (state) => state.tagApps,
  getWeiTuo: (state) => state.wtThings,
  getHighLights: (state) => state.highlights,
  getFavorites: (state) => state.favorites,
  getFavoriteApps: (state) => state.favoriteApps,
  getProcess: (state) => state.process_pass,
  getState: (state) => state,
  getDataSourceMap: (state) => state.apiMap,
  getDataSource: (state) => state.dataSource,
  getDataLength: (state) => state.dataLength,
  getIsShow: (state) => state.isShow,
  getPositions: (state) => state.positionsMes,
  getIsIdentity: (state) => state.isIdentity,
  getStatsRes: (state) => state.statsRes,
  getTodayVisit: (state) => state.todayVisit,
  getTotalVisit: (state) => state.totalVisit,
  getNowVisit: (state) => state.nowVisit,
  getAppQuery: (state) => state.appQuery,
};
const actions = {
  fetchAppList({ commit, state, dispatch }, filterApp) {
    commit("loadingData", true);
    dispatch("getTagsSort");
    dispatch("viewsVisitOnce");
        dispatch("viewsTodayVisitOnce");
        dispatch("viewsUserNum");

        // dispatch('getRecentApps')
        dispatch("getHotApps");
        dispatch("getSmartRecommendApps");
    apolloProvider.clients.appcenter
      .query({
        query: queryStr.userApps,
        variables: {},
        client: "other",
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        let appList = res.data.userApps
          .map((t) => {
            t.name = t.text;
            return t;
          })
          .filter((t) => t.trait === state.appVaryOnly && t.visible);

        if (appList && appList.length > 0) {
          var str = /^[A-Za-z]*$/;

          appList = appList.map((item) => {
            let shouzimu = "Z";
            //以数字开头
            let nowStrName = item.name;
            if (Number(nowStrName.slice(0, 1)) >= 0) {
              shouzimu = state.numPychar[Number(nowStrName.slice(0, 1))];
            }

            if (
              str.test(
                pyChar
                  .getFullChars(nowStrName)
                  .toUpperCase()
                  .slice(0, 1)
              )
            ) {
              shouzimu = pyChar
                .getFullChars(nowStrName)
                .toUpperCase()
                .slice(0, 1);
            }
            return {
              ...item,
              shouzimu,
            };
          });
          state.appList = appList.sort(
            (A, B) =>
              new Date(B.updated).getTime() - new Date(A.updated).getTime()
          );
        } else {
          state.appList = [];
        }

        // dispatch("metodoLength");
        // dispatch("ccsLength");

        commit("updateAppList");
        commit("updateAppAll");
        dispatch("favoriteGet");

        dispatch("getStatus", appList);

        
        commit("loadingData", false);
      })
      .catch((error) => {
        commit("loadingData", false);
        console.error(error);
      });
  },

  //请求所有标签内容，为了排序
  getTagsSort({ commit }) {
    for (let key of ["COMMON", "DEPARTMENT"]) {
      apolloProvider.clients.appcenter
        .query({
          query: queryStr.appTags,
          variables: {
            filter: { type: { eq: key } },
          },
          client: "appcenter",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let obj = {};
          let data = res.data.appTags;
          for (let d of data) {
            if (!d.parent && d.visible) {
              obj[d.text] = d.sort;
            }
          }
          state.tagsSort[key] = obj;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    commit("updateAppList");
  },

  //请求所有标签内容，为了排序
  getNoLoginTagsSort({ commit }) {
    for (let key of ["COMMON", "DEPARTMENT"]) {
      apolloProvider.clients.nologin
        .query({
          query: queryStr.appNoLoginTags,
          variables: {
            filter: { type: { eq: key } },
            tenant: window.commonApi.TENANT,
          },
          client: "nologin",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let obj = {};
          let data = res.data.anonymityAppTags;
          for (let d of data) {
            if (!d.parent && d.visible) {
              obj[d.text] = d.sort;
            }
          }
          state.tagsSort[key] = obj;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    commit("updateAppList", true);
  },

  getSmartRecommendApps({ commit, state, dispatch }) {
    state.recommendLoading = true;
    apolloProvider.clients.appcenter
      .query({
        query: queryStr.userRecommendationApps,
        variables: {},
        client: "other",
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        let apps = res.data.userRecommendationApps;
        if (apps && apps.length) {
          apps.sort((c, b) => {
            let cSort = 0;
            let bSort = 0;
            if (c && c.sort) {
              cSort = c.sort;
            }
            if (b && b.sort) {
              bSort = b.sort;
            }
            return bSort - cSort;
          });

          state.smartRecommendApps = apps;

          state.recommendLoading = false;

          // if(state && state.smartRecommendApps && !state.smartRecommendApps.length && apps.length){
          // }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },

  getHotApps({ commit, state, dispatch }) {
    // if (state.userHotApps.length == 0) {
      state.hotsLoading = true;
      state.userHotApps = [];
      apolloProvider.clients.appcenter
        .query({
          query: queryStr.userHotApps,
          variables: {
            first: 8,
            offset: 0,
          },
          client: "other",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let apps = res.data.hotApps;
          if (apps && apps.length) {
            state.userHotApps = apps
              .filter((t) => t.trait == state.appVaryOnly)
              .map((t) => {
                t.name = t.text;
                return t;
              });
          }
          state.hotsLoading = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally((e) => {
          state.hotsLoading = false;
        });
    // }
  },

  getNoLoginHotApps({ commit, state, dispatch }) {
    // if (state.userHotApps.length == 0) {
      state.hotsLoading = true;
      state.userHotApps = [];
      apolloProvider.clients.nologin
        .query({
          query: queryStr.userNoLoginHotApps,
          variables: { tenant: window.commonApi.TENANT },
          client: "nologin",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let apps = res.data.anonymityHotApps;
          if (apps && apps.length) {
            state.userHotApps = apps
              .filter((t) => t.trait == state.appVaryOnly)
              .map((t) => {
                t.name = t.text;
                return t;
              });
          }
          state.hotsLoading = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally((e) => {
          state.hotsLoading = false;
        });
    // }
  },

  getRecentApps({ commit, state, dispatch }) {
    if (state.userRecentApps.length == 0) {
      state.recentLoading = true;
      state.userRecentApps = [];
      apolloProvider.clients.appcenter
        .query({
          query: queryStr.userRecentApps,
          variables: {},
          client: "other",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let apps = res.data.userRecentApps;
          if (apps && apps.length) {
            state.userRecentApps = apps;
          }
          state.recentLoading = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally((e) => {
          state.recentLoading = false;
        });
    }
  },
  // 未登录接口
  async noLoginApps({ commit, state, dispatch }, data) {
    dispatch("viewsVisitOnce");
    dispatch("viewsTodayVisitOnce");
    dispatch("viewsUserNum");

    dispatch("getNoLoginTagsSort");
    dispatch("getNoLoginHotApps");
    dispatch("getNoLoginAppVisits");

    commit("loadingData", true);
    apolloProvider.clients.nologin
      .query({
        query: queryStr.anonymityApps,
        variables: { tenant: window.commonApi.TENANT },
        client: "nologin",
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        let appList = res.data.anonymityApps;
        state.appList = appList
          .map((t) => {
            t.name = t.text;
            let shouzimu = "Z";
            var str = /^[A-Za-z]*$/;
            //以数字开头
            let nowStrName = t.name;
            if (Number(nowStrName.slice(0, 1)) >= 0) {
              shouzimu = state.numPychar[Number(nowStrName.slice(0, 1))];
            }

            if (
              str.test(
                pyChar
                  .getFullChars(nowStrName)
                  .toUpperCase()
                  .slice(0, 1)
              )
            ) {
              shouzimu = pyChar
                .getFullChars(nowStrName)
                .toUpperCase()
                .slice(0, 1);
            }

            t.shouzimu = shouzimu;
            return t;
          })
          .filter((t) => t.trait == state.appVaryOnly && t.visible);
        
        commit("updateAppList", true);
        commit("updateAppAll");
        commit("loadingData", false);

        dispatch("statsAppList", appList);
      })
      .catch((error) => {
        commit("loadingData", false);
        console.error(error);
      });
  },
  //获取次数
  getStatus({ state, commit }, items) {
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/stats/apps`)
      .then((res) => {
        if (res.data.errno == 0) {
          state.statsRes = res.data.entities;
          commit("statsAppDates", items);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  // 未登录查询服务次数
  statsAppList({ state, commit, dispatch }, items) {
    axios
      .get(`${window.commonApi.TASKCENTER_API_URL}/api/noLogin/statsAppList`)
      .then((res) => {
        if (res.status == 200) {
          state.statsRes = res.data.entities;
          commit("statsAppDates", items);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  // 收藏列表
  favoriteGet({ commit }) {
    commit("loadingData", true);
    apolloProvider.clients.appcenter
      .query({
        query: queryStr.userFavoriteApps,
        variables: {},
        client: "appcenter",
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        let favorites = [];
        if (res.data.userFavoriteApps) {
          res.data.userFavoriteApps.forEach((item) => {
            favorites.push(item.id);
          });
        }
        state.favorites = favorites;
        commit("favoriteReset", favorites);
        commit("loadingData", false);
      })
      .catch((error) => {
        console.error(error);
        commit("loadingData", false);
      });
  },

  // 记录访问次数
  addFavoriteMethods({ commit, dispatch }, { type, appId }) {
    // type：1.点击应用访问  2.查看详情  3.收藏应用
    let record = { type, appId };
    apolloProvider.clients.appcenter
      .mutate({
        client: "appcenter",
        fetchPolicy: "no-cache",
        mutation: queryStr.createAppOperationRecord,
        variables: {
          record,
        },
      })
      .then((res) => {
        if (type == 3) {
          dispatch("favoriteGet");
          Message({
            message: "收藏成功",
            type: "success",
            duration: 1500,
          });
        } else {
          dispatch("getAppVisits");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  noLoginStat({ state }) {
    let varies = [
      { type: "AMOUNT", filter: { trait: { eq: state.appVaryOnly }}, tenant: window.commonApi.TENANT },
      {
        type: "AMOUNT",
        filter: { BLFS: { like: "线上" }, trait: { eq: state.appVaryOnly } },
        tenant: window.commonApi.TENANT,
      },
    ];
    for (let i = 0; i < varies.length; i++) {
      apolloProvider.clients.nologin
        .query({
          query: queryStr.appAnonymityStat,
          variables: varies[i],
          client: "nologin",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          if (
            res.data.anonymityAppStatistics &&
            res.data.anonymityAppStatistics.length
          ) {
            state.appLength[i] = res.data.anonymityAppStatistics[0].value;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },

  getAppListLength({ state, commit }) {
    let varies = [
      { type: "AMOUNT", filter: {trait: { eq: state.appVaryOnly }} },
      { type: "AMOUNT", filter: { BLFS: { like: "线上" }, trait: { eq: state.appVaryOnly } } },
    ];
    for (let i = 0; i < varies.length; i++) {
      apolloProvider.clients.appcenter
        .query({
          query: queryStr.appStat,
          variables: varies[i],
          client: "appcenter",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          state.appLength[i] = res.data.appStatistics[0].value;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },

  getAppVisits({ state, commit }) {
    // { type: "VIEW_BY_APP" }
    let varies = [{ type: "VISITS_BY_APP" }];
    for (let i = 0; i < varies.length; i++) {
      apolloProvider.clients.appcenter
        .query({
          query: queryStr.appStat,
          variables: varies[i],
          client: "appcenter",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          commit("updateAppStats", {
            data: res.data.appStatistics,
            key: varies[i].type,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },

  getNoLoginAppVisits({ state, commit }) {
    // { type: "VISITS_BY_APP" }, "VIEW_BY_APP"
    let varies = [{ type: "VISITS_BY_APP" }];
    for (let i = 0; i < varies.length; i++) {
      let variables = Object.assign(
        {
          tenant: window.commonApi.TENANT,
        },
        varies[i]
      );
      apolloProvider.clients.nologin
        .query({
          query: queryStr.appAnonymityStat,
          variables,
          client: "nologin",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          // console.log(res.data.anonymityAppStatistics, '-----')
          commit("updateAppStats", {
            data: res.data.anonymityAppStatistics,
            key: varies[i].type,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },

  // 记录取消收藏收藏访问次数
  reduceFavoriteMethods({ commit, dispatch }, id) {
    apolloProvider.clients.appcenter
      .mutate({
        client: "appcenter",
        fetchPolicy: "no-cache",
        mutation: queryStr.cancelAppCollect,
        variables: {
          app: id,
        },
      })
      .then((res) => {
        dispatch("favoriteGet");
        Message({
          message: "取消收藏成功！",
          type: "success",
          duration: 1500,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },

  metodo({ dispatch, commit }) {
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/me/tasks/todo`)
      .then((res) => {
        if (res.data.errno == 0) {
          let items = res.data.entities;
          commit("meTodoReset", items);
          dispatch("highChange");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  metodoLength({ dispatch, commit }) {
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/me/tasks/todo?limit=1&start=0`)
      .then((res) => {
        if (res.data.errno == 0) {
          state.dataLength.todo = res.data.total;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  ccsLength({ dispatch, commit }) {
    let params = {
      limit: 1,
      start: 0,
      unread: true,
    };
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/me/processes/cc`, { params })
      .then((res) => {
        if (res.data.errno == 0) {
          state.dataLength.cc = res.data.total;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  medoingsLength({ dispatch, commit }) {
    let params = {
      limit: 1,
      start: 0,
    };
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap["doing"].url}`, {
        params,
      })
      .then((res) => {
        if (res.data.errno == 0) {
          state.dataLength.doing = res.data.total;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  medonesLength({ dispatch, commit }) {
    let params = {
      limit: 1,
      start: 0,
    };
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap["done"].url}`, {
        params,
      })
      .then((res) => {
        if (res.data.errno == 0) {
          state.dataLength.done = res.data.total;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  async wtTodo({ commit }, { owner }) {
    let wt_owner = owner ? "entrustees" : "entrusters";
    let id = state.userInfos.id;
    commit("loadingData", true);
    await axios
      .get(`${window.commonApi.INFOPLUS_URL}/user/${id}/${wt_owner}`)
      .then((res) => {
        if (res.data.errno == 0) {
          let items = res.data.entities;
          commit("wtReset", { items, wt_owner });
          commit("loadingData", false);
        } else {
          commit("loadingData", false);
        }
      })
      .catch(function(error) {
        console.log(error);
        commit("loadingData", false);
      });
  },
  //删除委托
  delWt({ commit }, { id }) {
    let user = state.userInfos.id;
    axios
      .delete(`${window.commonApi.INFOPLUS_URL}/user/${user}/entrustees/${id}`)
      .then((res) => {
        if (res.data.errno == 0) {
          commit(`Message','success#删除成功#${new Date()}`);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  /*
   * 数据操作
   * */
  // 首页和 全部事项的搜索
  updateQuery({ commit, state }, { seq, tag, dep, other, zimu, blfs }) {
    state.appQuery.seq = seq || state.appQuery.seq;
    state.appQuery.tag = tag || state.appQuery.tag;
    state.appQuery.department = dep || state.appQuery.department;
    state.appQuery.other = other || state.appQuery.other;
    state.appQuery.zimu = zimu || state.appQuery.zimu;

    console.log("=====");
    //办理方式
    state.appQuery.blfs = blfs || state.appQuery.blfs;
    if (seq === "all") {
      state.appQuery.seq = "";
    }
    if (tag === "all") {
      state.appQuery.tag = "";
    }
    if (dep === "all") {
      state.appQuery.department = "";
    }
    if (other === "all") {
      state.appQuery.other = "";
    }
    if (zimu === "all") {
      state.appQuery.zimu = "";
    }

    if (blfs === "all") {
      state.appQuery.blfs = "";
    }

    commit("updateAppAll");
  },
  //抄送变为已读
  async flow_read({ dispatch, state, commit }, { ids, unread }) {
    let ccs = ids.split(",");
    console.log(ccs);
    for (let i in ccs) {
      await axios
        .post(
          `${window.commonApi.INFOPLUS_URL}/process/${ccs[i]}`,
          qs.stringify({ action: "read" })
        )
        .then((res) => {
          if (res.data.errno == 0) {
            commit("Message", `success#已标记为已读#${new Date()}`);
            dispatch("resetData", { dataName: "flow_cc" });
          }
        })
        .catch(function(error) {
          // commit('Message', `error#${error.message}`);
          console.log(error);
        });
    }
  },
  //评分
  Rated({ state, dispatch, commit }, { id, rating, review }) {
    axios
      .post(
        `${window.commonApi.INFOPLUS_URL}/process/${id}`,
        qs.stringify({
          action: "rate",
          rating: rating,
          remark: review,
        })
      )
      .then((res) => {
        if (res.data.errno == 0) {
          commit("Message", `success#评分成功#${new Date()}`);
          dispatch("resetData", {
            dataName: "done",
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        commit("Message", `error#${error.message}`);
      });
  },
  //需要批量办理时候的多选框
  process_push({ commit, state }, { id, isok, clear }) {
    if (isok) {
      state.process_pass.push(id);
    } else {
      let arr = state.process_pass
        .join(",")
        .replace(`${id}`, "")
        .split(",")
        .filter((item) => {
          return item;
        });
      state.process_pass = arr;
    }

    if (clear) {
      state.process_pass = [];
    }
    // console.log(state.process_pass)
    state.process_pass = Array.from(new Set(state.process_pass));
  },
  //批量办理
  process_many({ dispatch, state }, actionId) {
    state.process_pass.map((id) => {
      axios
        .post(
          `${window.commonApi.INFOPLUS_URL}/task/${id}`,
          qs.stringify({ actionId: actionId })
        )
        .then((res) => {
          if (res.data.errno == 0) {
            dispatch("resetData", { dataName: "todo" });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    });
  },
  //单独一个快捷办理
  process_one({ dispatch, state }, { actionId, id }) {
    axios
      .post(
        `${window.commonApi.INFOPLUS_URL}/task/${id}`,
        qs.stringify({ actionId: actionId })
      )
      .then((res) => {
        if (res.data.errno == 0) {
          dispatch("resetData", { dataName: "todo" });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  //获取流程细节
  processTask({ commit, state }, id) {
    axios
      .get(`${window.commonApi.INFOPLUS_URL}/process/${id}`)
      .then((res) => {
        if (res.data.errno == 0) {
          let items = res.data.entities[0];
          return items;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  //本地存储置顶，逻辑
  highChange({ commit, state }) {
    let user = state.oidcStore.user.email;
    let highlights = localStorage
      .getItem(`${user}_top`)
      .split(",")
      .filter((item) => {
        return item;
      });
    commit("HighLightReset", highlights);
  },
  //点击爱心按钮,逻辑
  favoriteNow({ commit }, { id, method }) {
    if (method === "put") {
      axios
        .put(
          `${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`
        )
        .then((res) => {
          if (res.data.errno == 0) {
            let items = res.data.entities[0].FavoriteApps;
            commit("favoriteReset", items);
          } else {
            sessionStorage.setItem("error_res_now", res.data.error);
          }
        })
        .catch(function(error) {
          console.log(error);
          sessionStorage.setItem("error_res_now", error);
        });
    } else {
      axios
        .delete(
          `${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps/${id}`
        )
        .then((res) => {
          if (res.data.errno == 0) {
            let items = res.data.entities[0].FavoriteApps;
            commit("favoriteReset", items);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  getPositionsMes({ commit, state }, id) {
    axios
      .get(`${window.commonApi.PATH}/api/user/positions?id=${id}`)
      .then((res) => {
        if (res.data.errno == 0) {
          state.positionsMes = res.data.entities;
          commit("postIdentity", state.positionsMes);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  //将参数原始化
  ClearQ({ commit, state, dispatch }, { dataName }) {
    let origin_query = {
      limit: 10,
      start: 0,
      unread: false,
      keyword: "",
      lastUpdate: null,
    };
    let origin = state.apiMap[dataName];
    if (origin && origin.query) {
      for (let key in origin_query) {
        if (origin.query.hasOwnProperty(key)) {
          origin.query[key] = origin_query[key];
        }
      }
      state.apiMap[dataName].query = origin.query;
    }
    dispatch("resetData", { dataName, query: origin.query });
  },
  //添加后来的参数，如timestamp
  AddQ({ state, dispatch }, { dataName, property, val }) {
    if (!state.apiMap[dataName].query.hasOwnProperty(property)) {
      state.apiMap[dataName].query[property] = val;
      dispatch("resetData", { dataName, query: state.apiMap[dataName].query });
    } else {
      dispatch("SearchQ", { key: dataName, property, val });
    }
  },
  //调用接口的搜索  limitRefresh限制刷新
  SearchQ({ dispatch, commit }, { key, property, val, limitRefresh }) {
    let str1 = JSON.stringify(state.apiMap[key].query);
    state.apiMap[key].query[property] = val;
    let str2 = JSON.stringify(state.apiMap[key].query);
    if (property != "start" && property != "limit") {
      state.apiMap[key].query["start"] = 0;
    }
    let query = state.apiMap[key].query;
    let dataName = key;
    //更改参数
    commit("ChangeQ", { dataName, query });

    if (str1 != str2 && !limitRefresh) {
      dispatch("resetData", { dataName, query });
    }
  },
  // 大厅记录访问量(终端和流程)
  recordVisitOnce({ commit }, labelName) {
    let params = {
      labelName: labelName,
    };
    axios
      .get(`/taskcenter-v4/api/accessRecord`, { params })
      .then((res) => {})
      .catch(function(error) {
        console.log(error);
      });
  },
  // 查询所有的访问量
  viewsVisitOnce({ state }, labelName) {
    axios
      .get(`${window.commonApi.TASKCENTER_API_URL}/api/noLogin/visit`)
      .then((res) => {
        if (res.data && res.data[0]) {
          state.totalVisit = res.data[0].count;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  // 查询今天访问量
  viewsTodayVisitOnce({ state }, labelName) {
    axios
      .get(`${window.commonApi.TASKCENTER_API_URL}/api/noLogin/visitToday`)
      .then((res) => {
        if (res.data && res.data[0]) {
          state.todayVisit = res.data[0].count > 1 ? res.data[0].count : 1;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  // 查询访问人数
  viewsUserNum({ state }, labelName) {
    axios
      .get(`${window.commonApi.TASKCENTER_API_URL}/api/noLogin/visit/timestamp`)
      .then((res) => {
        if (res.data && res.data[0]) {
          state.nowVisit = res.data[0].count;
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  async resetData({ commit, state, dispatch }, { dataName, query }) {
    commit("loadingData", true);
    let url = state.apiMap[dataName].url;
    let params = Object.assign({}, query || state.apiMap[dataName].query);

    if (params.hasOwnProperty("unread") && !params.unread) {
      delete params.unread;
    }
    if (params.hasOwnProperty("keyword") && !params.keyword) {
      delete params.keyword;
    }
    if (params.hasOwnProperty("timestamps") && !params.timestamps) {
      delete params.timestamps;
    }
    if (params.hasOwnProperty("lastUpdate") && !params.lastUpdate) {
      delete params.lastUpdate;
    }
    await axios
      .get(`${window.commonApi.INFOPLUS_URL}/${url}`, {
        params,
        headers: {
          'Cache-Control': 'no-cache'
        } })
      .then((res) => {
        if (res.data.errno == 0) {
          let items = res.data.entities;
          let total = res.data.total;
          commit("dataGet", { items, total, dataName });
          console.log(dataName + "初始化成功！");
          commit("loadingData", false);
          switch (dataName) {
            case "todo":
              dispatch("highChange");
              break;
            case "flow_cc":
              dispatch("ccsLength");
              break;
          }
        } else {
          commit("loadingData", false);
        }
      })
      .catch(function(error) {
        console.log(error);
        commit("loadingData", false);
      });
  },
};
const mutations = {
  getRecent(state, val) {
    state.recent = val;
    localStorage.setItem("recent", JSON.stringify(val));
    console.log(val);
  },
  //全局移动端抽屉
  setShortcutVisible(state, bool) {
    state.shortcutVisible = bool;
  },
  updateTotalTip(state, value) {
    state.totalTip = value;
    console.log(state.totalTip);
  },
  // 判断当前登陆人是否包含 本科生、专科生（学号）  教职工（教工号）
  postIdentity(state, identArr) {
    let studentArr = identArr.filter(
      (item) => item.post.name == "本科生" || item.post.name == "专科生"
    );
    let teacherArr = identArr.filter((item) => item.post.name == "教职工");
    if (studentArr.length > 0) {
      state.isIdentity = "学号";
    } else if (teacherArr.length > 0) {
      state.isIdentity = "教工号";
    }
  },

  updateAppList(state, onlyTourist) {
    // if (apps) {
    //   state.appList = apps;
    // }
    console.log('-----?',onlyTourist,state.appList.length)
    
    let appListOrigin = Object.assign([], state.appList);
    let appList = state.appList;

    if(onlyTourist){
      state.appList = appList.filter((t)=>t.dynamicAttributes && t.dynamicAttributes.FWDX && t.dynamicAttributes.FWDX.includes('游客'))
    }

    if (appList.length) {
      let recommends = [];
      let tags = [];
      let department = [];
      let appIdIcons = {};
      let otherTags = {};
      let serviceObjTags = [];
      let BLFS = [];

      if (appList.length > 0) {
        for (let i in appList) {
          let obj = appList[i];
          if (obj.tags) {
            let cutTags = obj.tags.split(",");
            tags = tags.concat(cutTags);
          }

          if (obj.dynamicAttributes && obj.dynamicAttributes.FWDX) {
            let cutTags =
              JSON.parse(obj.dynamicAttributes.FWDX) ||
              obj.dynamicAttributes.FWDX;
            // .split(",");
            serviceObjTags = serviceObjTags.concat(cutTags);
          }

          if (obj.dynamicAttributes && obj.dynamicAttributes.BLFS) {
            let cutTags = obj.dynamicAttributes.BLFS.split(",");
            BLFS = BLFS.concat(cutTags);
          }

          if (obj.department) {
            let deptss = obj.department.split(",");
            department = department.concat(deptss);
          }

          if (obj.icon) {
            appIdIcons[obj.id] = obj.icon;
          }
        }

        recommends = appListOrigin.filter((item) => {
          return item.recommend && item.recommend > 0;
        });

        tags = Array.from(new Set(tags));
        department = Array.from(new Set(department));
        serviceObjTags = Array.from(new Set(serviceObjTags));
        BLFS = Array.from(new Set(BLFS));
      }

      let sortOrigins = state.tagsSort;
      state.recommends = recommends;

      tags = Object.keys(sortOrigins["COMMON"]);
      // console.log(tags, sortOrigins["COMMON"], '-----tags')
      state.tags = tags.sort((a, b) => {
        let a_num = sortOrigins["COMMON"][a] || Infinity;
        let b_num = sortOrigins["COMMON"][b] || Infinity;
        return a_num - b_num;
      });

      // tags.sort((a, b) => {
      //   let a_num = sortOrigins["COMMON"] ? sortOrigins["COMMON"][a] : Infinity;
      //   let b_num = sortOrigins["COMMON"] ? sortOrigins["COMMON"][b] : Infinity;
      //   return a_num - b_num;
      // });
      state.department = department.sort((a, b) => {
        let a_num = sortOrigins["DEPARTMENT"]
          ? sortOrigins["DEPARTMENT"][a]
          : Infinity;
        let b_num = sortOrigins["DEPARTMENT"]
          ? sortOrigins["DEPARTMENT"][b]
          : Infinity;
        return a_num - b_num;
      });
      state.appIdIcons = appIdIcons;
      state.otherTags = serviceObjTags;

      state.serviceObjTags = serviceObjTags;

      state.BLFS = BLFS;

      state.loadingDataStart = false;
    }
  },
  updateAppAll(state, appList) {
    if (appList) {
      state.appList = appList;
    }
    let all_apps = state.appList;
    let filtered_apps = [];

    for (let key in all_apps) {
      let objNow = all_apps[key];
      objNow.department = objNow.department || " ";
      let limit = [false, false, false, false, false, false];

      if (
        state.appQuery.seq &&
        objNow.text.indexOf(state.appQuery.seq) === -1
      ) {
        limit[0] = true;
      }

      if (state.appQuery.tag) {
        if (
          !objNow.tags ||
          (objNow.tags && objNow.tags.indexOf(state.appQuery.tag) === -1)
        ) {
          limit[1] = true;
        }
      }

      if (state.appQuery.other) {
        let butes = objNow.dynamicAttributes || {};
        let nowOther = state.appQuery.other;
        let parseStr = {
          学生: ["本科生", "研究生", "留学生", "校友"],
        };

        console.log(state.appQuery.other, butes.FWDX);

        if (!butes.FWDX) {
          limit[2] = true;
        } else {
          let hasO = false;
          if (parseStr[nowOther]) {
            for (let tag of parseStr[nowOther]) {
              if (butes.FWDX.indexOf(tag) !== -1) {
                hasO = true;
              }
            }
          } else {
            if (butes.FWDX.indexOf(nowOther) !== -1) {
              hasO = true;
            }
          }

          limit[2] = !hasO;
        }
      }

      // if (
      //   objNow.tags ||
      //   (state.appQuery.other && state.appQuery.other.length)
      // ) {
      //   let others = state.appQuery.other;
      //   let i = 0;
      //   let findNo = false;
      //   while (i < others.length && !findNo) {
      //     let str = objNow.tags || '';
      //     if (str.indexOf(others[i]) == -1) {
      //       findNo = true;
      //     }
      //     i++;
      //   }
      //   limit[2] = findNo;
      // }
      if (
        state.appQuery.department &&
        objNow.department.indexOf(state.appQuery.department) === -1
      ) {
        limit[3] = true;
      }

      if (state.appQuery.zimu) {
        let butes = objNow.dynamicAttributes || {};
        if (objNow.shouzimu !== state.appQuery.zimu) {
          limit[4] = true;
        }
      }

      if (state.appQuery.blfs) {
        let butes = objNow.dynamicAttributes || {};
        if (!butes.BLFS || butes.BLFS.indexOf(state.appQuery.blfs) === -1) {
          limit[5] = true;
        }
      }

      // console.log(limit);

      if (limit.indexOf(true) === -1) {
        filtered_apps.push(objNow);
      }
    }

    let zimuS = filtered_apps.map((item) => {
      return item.shouzimu;
    });

    if (!Object.values(state.appQuery).join("")) {
      state.zimu = Array.from(new Set(zimuS)).sort();
    }

    state.tagApps = filtered_apps;
    state.loadingDataStart = false;
  },

  updateAppStats(state, { data, key }) {
    let Amap = {};
    for (let i = 0; i < data.length; i++) {
      let code = data[i].text || data[i].name;
      let value = data[i].value;
      Amap[code] = value;
    }
    // console.log(Amap);
    state.appVisits = Amap;
    // [key]
  },

  CcthingsReset(state, { items, total }) {
    let sort_ccthings = items.sort((a, b) => {
      if (a.read && b.read) {
        return 0;
      } else if (a.read && !b.read) {
        return -1;
      } else {
        return 1;
      }
    });
    state.ccthings.total = total;
    state.ccthings.val = sort_ccthings;
  },

  favoriteReset(state, favorites) {
    state.favorites = favorites;
    state.favoriteApps = state.favorites
      .map((item1) => {
        return state.appList.filter((item2) => item2.id === item1)[0];
      })
      .filter((exit) => exit);
  },
  statsAppDates(state, items) {
    state.statsRes.appList = items.map((item) => {
      let id1 = item.id;
      let item2 = state.statsRes.filter((item) => {
        return item.id === id1;
      });
      let counts = item2[0] ? item2[0].processCounters.completed : 0;
      item.processCounters = counts;
      return item;
    });
  },

  wtReset(state, { items, wt_owner }) {
    state.wtThings[wt_owner] = items;
  },

  HighLightReset(state, highlights) {
    // console.log(highlights);
    state.highlights = highlights.filter((item) => {
      return item;
    });
  },

  dataGet(state, { items, total, dataName }) {
    state.dataSource[dataName] = items;
    state.dataLength[dataName] = total;
  },

  ChangeQ(state, { dataName, query }) {
    state.apiMap[dataName].query = Object.assign({}, query);
  },

  //骨架屏
  loadingData(state, load_bool) {
    state.loadingDataStart = load_bool;
  },

  isShow(state, val) {
    state.isShow = val;
  },

  //传递消息
  Message(state, word) {
    state.targetMessage = word;
  },

  //长链接
  toIsCanFresh(state, bool) {
    state.isCanFresh = bool;
  },

  //profile问题
  setUserInfo(state, obj) {
    state.userInfos = Object.assign({}, obj);
  },
};

const modules = {
  manageGuide: manageGuide,
  appProjects: appProjects,
  oidcStore: vuexOidcCreateStoreModule(
    oidcSettings,
    // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
    // spread your oidcSettings and define a userStore of your choice
    // {
    //     ...oidcSettings,
    //     //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
    // },
    // Optional OIDC store settings
    {
      namespaced: true,
      dispatchEventsOnWindow: true,
    },
    // Optional OIDC event listeners
    {
      userLoaded: (user) => console.log("OIDC user is loaded:", user),
      userUnloaded: () => console.log("OIDC user is unloaded"),
      accessTokenExpiring: () => console.log("Access token will expire"),
      accessTokenExpired: () => console.log("Access token did expire"),
      silentRenewError: () => console.log("OIDC user is unloaded"),
      userSignedOut: () => console.log("OIDC user is signed out"),
      oidcError: (payload) => console.log("OIDC error", payload),
    }
  ),
};

export default {
  modules,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js